import type { ToyConfig } from '../types';

export interface GrabResult {
  success: boolean;
  nearMiss: boolean;
  roll: number;
  probability: number;
  accuracy: number;
  toy: ToyConfig;
}

export class GrabSystem {
  // Kept for API compatibility; thresholds are now pure-skill constants.
  constructor(_nearMissRate: number, _version = 'B') {}

  attempt(toy: ToyConfig, accuracy: number): GrabResult {
    // Pure skill-based hit check.
    // accuracy > 0.80 means the claw is centered enough → guaranteed grab.
    // accuracy > 0.60 means close but not enough → near-miss feedback.
    // accuracy <= 0.60 means plain miss.
    const threshold = 0.8;
    const nearMissThreshold = 0.6;

    const success = accuracy > threshold;
    const nearMiss = !success && accuracy > nearMissThreshold;

    return {
      success,
      nearMiss,
      roll: 0,
      probability: success ? 1 : 0,
      accuracy,
      toy,
    };
  }
}
